import React from 'react';
import {useIntl} from 'react-intl';
import {useParams} from 'react-router-dom';
import {useHeader} from '../../../../_metronic/layout';
import SectionsContainer from '../components/SectionsContainer';
import {CustomerDetailsUIProvider} from '../components/CustomerDetailsUIContext';

const CustomerDetails = () => {
  const {customerID, greenInvoiceClientID} = useParams();
  const header = useHeader();
  const intl = useIntl();
  const editCustomerHeader = intl.formatMessage({
    id: 'customer-details-page-header',
    defaultMessage: 'Edit customer',
  });

  header.setTitle(editCustomerHeader);

  return (
    <div className={'pt-8'}>
      <CustomerDetailsUIProvider
      customerID={customerID}
      greenInvoiceClientID={greenInvoiceClientID !== 'notGiClient' ? greenInvoiceClientID : null}
    >
      <SectionsContainer/>
    </CustomerDetailsUIProvider>
    </div>
  );
};

export default CustomerDetails;
